import React from 'react'
import PropTypes from 'prop-types'
import {
  DescriptionText,
  ErrorText,
  FieldWrapper,
  HeaderText,
  Label,
  LabelText,
  QuestionText,
  QuestionWrapper,
  RadioCircle,
  RadioField,
  SelectionsWrapper,
  StyledWarningIcon,
  StyledHr,
} from './component.styles'

const AddUserPlan = ({ errors, modalData, touched, values }) => {
  const { bodyCopy, header, choiceContent } = modalData

  return (
    <React.Fragment>
      <HeaderText>{header}</HeaderText>
      <DescriptionText>{bodyCopy}</DescriptionText>
      <QuestionWrapper>
        <QuestionText>{choiceContent?.[0]?.questionText}</QuestionText>
        <StyledHr />
        <SelectionsWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.userInvitationMethod === 'DuringKickoffMeeting'}
              id="duringKickoffMeeting"
              name="userInvitationMethod"
              type="radio"
              value="DuringKickoffMeeting"
            />
            <RadioCircle htmlFor="duringKickoffMeeting" />
            <Label for="duringKickoffMeeting">
              <LabelText>{choiceContent?.[0]?.answerChoice1Long}</LabelText>
            </Label>
          </FieldWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.userInvitationMethod === 'Now'}
              id="now"
              name="userInvitationMethod"
              type="radio"
              value="Now"
            />
            <RadioCircle htmlFor="now" />
            <Label for="now">
              <LabelText>{choiceContent?.[0]?.answerChoice2Long}</LabelText>
            </Label>
          </FieldWrapper>
          <FieldWrapper>
            <RadioField
              checked={values.userInvitationMethod === 'AlreadyComplete'}
              id="alreadyComplete"
              name="userInvitationMethod"
              type="radio"
              value="AlreadyComplete"
            />
            <RadioCircle htmlFor="alreadyComplete" />
            <Label for="alreadyComplete">
              <LabelText>{choiceContent?.[0]?.answerChoice3Long}</LabelText>
            </Label>
          </FieldWrapper>
        </SelectionsWrapper>
        {touched.userInvitationMethod && errors.userInvitationMethod && (
          <ErrorText>
            <StyledWarningIcon />
            {errors.userInvitationMethod}
          </ErrorText>
        )}
      </QuestionWrapper>
    </React.Fragment>
  )
}

AddUserPlan.propTypes = {
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  modalData: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
}

export default AddUserPlan
